module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getReservationCalculations && !_vm.noTicketsSelected) ? _c('div', {
    staticClass: "bg-darker lightest mt-2 py-2 px-4"
  }, [_c('div', [_c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-baseline"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', {
    staticClass: "font-weight-600 fs-largest"
  }, [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', {
    staticClass: "font-weight-600 fs-largest"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotal)) + " €")])]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-baseline"
  }, [(_vm.getReservationCalculations.entityCommissionToComponentType == 1) ? _c('span', [_vm._v("Discount (" + _vm._s(_vm.getReservationCalculations.entityCommissionToComponentValue) + "%)")]) : _vm._e(), _vm._v(" "), (_vm.getReservationCalculations.entityCommissionToComponentType == 0) ? _c('span', [_vm._v("Discount (" + _vm._s(_vm.getReservationCalculations.entityCommissionToComponentValue) + "€)")]) : _vm._e(), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalDiscounts)) + " €")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-baseline"
  }, [_c('span', [_c('span', [_vm._v("Deposit")]), _vm._v(" "), (_vm.getReservationCalculations.depositPaymentType == 2 && _vm.getReservationCalculations.depositType == 1) ? _c('span', [_vm._v(" (" + _vm._s(_vm.getReservationCalculations.depositValue) + "%)")]) : _vm._e(), _vm._v(" "), (_vm.getReservationCalculations.depositPaymentType == 1) ? _c('span', [_vm._v(" (Full amount)")]) : _vm._e()]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotalDepositValueRequired)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-baseline"
  }, [_vm._m(0), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotalCommission)) + " €")])]), _vm._v(" "), _vm._l((_vm.comissionTypes), function(commissionType) {
    return (commissionType.active) ? _c('div', {
      staticClass: "d-flex flex-row justify-content-between align-items-baseline mt-1 medium"
    }, [_c('span', {
      staticClass: "d-flex align-items-center ml-2"
    }, [_vm._v("\n                    " + _vm._s(commissionType.label) + " \n                    "), (!_vm.isEditingCommissions[commissionType.type.toLowerCase()]) ? _c('span', {
      staticClass: "px-1"
    }, [_vm._v("\n                        (" + _vm._s(_vm.localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'Value']) + _vm._s(_vm.localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 1 ? '%' : '€') + ")\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.isEditingCommissions[commissionType.type.toLowerCase()]) ? _c('span', {
      staticClass: "d-flex px-1 align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'Value']),
        expression: "localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'Value']",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "glued-right px-2 py-0 text-center border-medium",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'Value'])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.localReservation.currentChannelCommission, commissionType.type.toLowerCase() + 'Value', _vm._n($event.target.value))
        }, function($event) {
          return _vm.overrideCommissionChanged($event, commissionType.type)
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), (_vm.localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 1) ? _c('div', {
      staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
      staticStyle: {
        "width": "auto !important"
      },
      on: {
        "click": function($event) {
          return _vm.switchCommissionType(commissionType.type)
        }
      }
    }, [_vm._v("%")]) : _vm._e(), _vm._v(" "), (_vm.localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 0) ? _c('div', {
      staticClass: "glued-left w-25 py-0 px-1 pointer dark border-medium",
      staticStyle: {
        "width": "auto !important"
      },
      on: {
        "click": function($event) {
          return _vm.switchCommissionType(commissionType.type)
        }
      }
    }, [_vm._v("€")]) : _vm._e(), _vm._v(" "), (_vm.localReservation.currentChannelCommission['isToOverwrite' + commissionType.type]) ? _c('button', {
      staticClass: "btn secondary small fs-small mx-1",
      attrs: {
        "disabled": _vm.noTicketsSelected
      },
      on: {
        "click": function($event) {
          return _vm.updateCommissions(commissionType)
        }
      }
    }, [_vm._v("Apply")]) : _vm._e()]) : _c('span', [(!_vm.localReservation.attachPromocode && (_vm.localReservation.attachPromocodeType === 0 || !_vm.localReservation.attachPromocodeType)) ? _c('button', {
      staticClass: "btn secondary small fs-small mx-1",
      attrs: {
        "disabled": _vm.noTicketsSelected
      },
      on: {
        "click": function($event) {
          return _vm.editingCommissionToogle(commissionType.type)
        }
      }
    }, [_vm._v(_vm._s(_vm.isEditingCommissions[commissionType.type.toLowerCase()] ? 'Use default' : 'Edit'))]) : _vm._e()])]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
      attrs: {
        "size": "small",
        "opacity": "0.2"
      }
    })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations['total' + commissionType.type + 'CommissionToEntityGrossprice'])) + " €")])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "bg-color-1 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer",
    class: {
      'disabled': _vm.noTicketsSelected || _vm.$v.$invalid || !_vm.sideBarOriginAndSegmentIsReadyToSubmit
    },
    attrs: {
      "disabled": _vm.noTicketsSelected || _vm.$v.$invalid || _vm.getIsAddingReservation || _vm.getIsLoadingCalculations || !_vm.sideBarOriginAndSegmentIsReadyToSubmit || _vm.genderPriceDependencies || !_vm.promocodeIsValid
    },
    on: {
      "click": function($event) {
        return _vm.openReservationPayIn()
      }
    }
  }, [_vm._v("\n                Payment\n        ")]), _vm._v(" "), (_vm.enabledStatusStripeIntegration) ? _c('button', {
    staticClass: "bg-color-1 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer ml-2",
    class: {
      'disabled': _vm.noTicketsSelected || _vm.$v.$invalid || !_vm.sideBarOriginAndSegmentIsReadyToSubmit
    },
    attrs: {
      "disabled": _vm.noTicketsSelected || _vm.$v.$invalid || _vm.getIsAddingReservation || _vm.getIsLoadingCalculations || !_vm.sideBarOriginAndSegmentIsReadyToSubmit || _vm.genderPriceDependencies || !_vm.promocodeIsValid
    },
    on: {
      "click": function($event) {
        return _vm.openReservationLinkIn()
      }
    }
  }, [_vm._v("Payment Link\n        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer ml-2",
    class: {
      'disabled': _vm.noTicketsSelected || _vm.$v.$invalid || !_vm.sideBarOriginAndSegmentIsReadyToSubmit
    },
    attrs: {
      "disabled": _vm.noTicketsSelected || _vm.$v.$invalid || _vm.getIsAddingReservation || _vm.getIsLoadingCalculations || !_vm.sideBarOriginAndSegmentIsReadyToSubmit || _vm.genderPriceDependencies || !_vm.promocodeIsValid
    },
    on: {
      "click": function($event) {
        return _vm.saveReservation(false)
      }
    }
  }, [_vm._v("Save\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer ml-2",
    class: {
      'disabled': _vm.noTicketsSelected || _vm.$v.$invalid || !_vm.sideBarOriginAndSegmentIsReadyToSubmit
    },
    attrs: {
      "disabled": _vm.noTicketsSelected || _vm.$v.$invalid || _vm.getIsAddingReservation || _vm.getIsLoadingCalculations || !_vm.sideBarOriginAndSegmentIsReadyToSubmit || _vm.genderPriceDependencies || !_vm.promocodeIsValid
    },
    on: {
      "click": function($event) {
        return _vm.saveReservation(true)
      }
    }
  }, [_vm._v("Save & Print\n        ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', [_vm._v("Comissions (total)")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-79740bbb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79740bbb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Summary/TotalAndPay.vue
// module id = 2849
// module chunks = 0